
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const UpdateCupom = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CUPOM_UPDATE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'CUPOM_UPDATE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'CUPOM_UPDATE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'CUPOM_UPDATE_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default UpdateCupom